<template>
  <div class="snapshot">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <div class="table-agile-info">
            <div class="common-new-title mode2">
              <span>资源重复列表</span>
            </div>
            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">客户编号</label>
                <el-input
                  clearable
                  class="jm-input280"
                  v-model="searchData.id"/>
              </div>
              <div class="box-content">
                <label class="form-tit">客户姓名</label>
                <el-input
                  clearable
                  class="jm-input280"
                  v-model="searchData.username"/>
              </div>
              <div class="box-content">
                <label class="form-tit">电话</label>
                <el-input
                  clearable
                  class="jm-input280"
                  v-model="searchData.tel"/>
              </div>
              <div class="box-content">
                <label class="form-tit">重复进入时间</label>
                <el-date-picker
                  clearable
                  class="jm-input280"
                  v-model="searchData.creationDate"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <div class="box-content">
                <label class="form-tit">采集功能</label>
                <el-select
                  filterable
                  clearable
                  v-model="searchData.ct_create_person"
                  class="jm-input280"
                  placeholder="请选择">
                  <el-option
                    v-for="item in createPersonZZ"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">当前客户状态</label>
                <jm-dict-select
                  clearable
                  v-model="searchData.ct_customer_status"
                  class="jm-input280"
                  type="dataset"
                  dict-type="training"
                  name="trainingLevelType"
                />
              </div>
              <div class="box-content">
                <label class="form-tit">
                  是否去重
                  <el-tooltip placement="bottom-start" effect="light">
                    <div slot="content">
                      如果有多条相同重复进入创建人的记录，默认去除重复记录，仅显示最后进入的记录。<br />开启重复，会显示多条相同结果。
                    </div>
                    <i class="el-icon-question blue"/>
                  </el-tooltip>
                </label>
                <el-switch
                  v-model="searchData.not_duplicate"
                  active-text="是"
                  inactive-text="否">
                </el-switch>
              </div>
            </div>
            <div class="search-btn">
              <el-button
                class="jm-input135"
                type="primary"
                @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
              <el-button
                class="jm-input135"
                type="default"
                @click="resetFields">重置</el-button>
              <el-button
                class="jm-input135"
                type="success"
                @click="exportDetails"
                :loading="btnLoading">导出明细</el-button>
            </div>
            <!--列表部分 start -->
            <jm-tableList
              url="/training/snapshot/getPaginate"
              :search-data="searchData"
            >
              <el-table-column
                fixed="right"
                slot="lastColumn"
                label="操作"
                :min-width="40"
                class-name="scope-button-list">
                <template slot-scope="scope">
                  <router-link target="_blank" :to="{ name: 'resourceSnapshot', params: { id: scope.row.user_id, customer_id: scope.row.id } }">
                    <el-button type="primary" size="mini">查看</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--列表部分 end-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatSelectGroupData } from '@/utils/utils.js';
import { jmDictSelect } from '@/components/tool';

function getDefaultSearch() {
  return {
    id: '',
    tel: '',
    username: '',
    ct_customer_status: '',
    ct_create_person: '',
    creationDate: [],
    not_duplicate: true,
  };
}
export default {
  data() {
    return {
      searchData: getDefaultSearch(),
      btnLoading: false,
      ds: {
        create_person: {
          ZZ: []
        }
      },
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    jmDictSelect
  },
  methods: {
    // 获取页面数据
    getPageData() {
      // 获取字典
      this.$http
        ._post({
          url: '/training/snapshot/searchDs'
        })
        .then((res) => {
          this.ds = res.data;
          this.ds.create_person = formatSelectGroupData(res.data.create_person);
        });
    },
    // 重置搜索
    resetFields() {
      this.searchData = getDefaultSearch();
      this.$store.commit('updateRefresh', true);
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/training/snapshot/downloadExport',
          data: {
            searchData: this.searchData,
            pageSize: 1000
          }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '考培重复资源列表.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  },
  mounted() {
    this.getPageData();
  },
  computed: {
    createPersonZZ() {
      if (this.ds.create_person && this.ds.create_person.ZZ) {
        return this.ds.create_person.ZZ.filter(item => item.userid < 0);
      }
      return [];
    },
  }
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
  .blue {
    color: #409EFF;
  }
</style>
